import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HotActivities() {
  const featured = articles.filter((a) => a.featured);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">热门活动推荐</h2>
            <p className="text-sm text-foreground-500">精选最值得关注的注册送彩金活动</p>
          </div>
          <Link
            to="/category/platform-recommend"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col sm:flex-row bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full sm:w-56 h-44 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-md whitespace-nowrap">推荐</span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{article.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}